/* eslint-disable react/no-unescaped-entities */
"use client";

import React, { useState, useRef, useEffect } from "react";

import Heading from "@/components/heading/heading";
import Button from "@/components/button/Button";

import Arrow from "@/public/svg/arrow-right.svg";
import Buttonwhatsapp from "@/public/svg/common/social-icons/whatsapp.svg";
import RightIcon from "@/public/svg/line-arrow-right.svg";

import Image from "next/image";

import "@/sections/common/tariff/tariff.scss";

const Tariff = () => {
    const [showSecondContainer, setShowSecondContainer] = useState(false);
    const secondContainerRef = useRef<HTMLDivElement | null>(null);

    const handleViewMore = () => {
        setShowSecondContainer(true);
    };

    const handleViewLess = () => {
        setShowSecondContainer(false);

        const familyPackagesElement = document.getElementById("tariffsection");
        if (familyPackagesElement) {
            familyPackagesElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (secondContainerRef.current) {
            if (showSecondContainer) {
                // Set max-height to the actual height of the content for smooth transition
                const contentHeight = secondContainerRef.current.scrollHeight;
                secondContainerRef.current.style.maxHeight = `${contentHeight}px`;
            } else {
                secondContainerRef.current.style.maxHeight = "0";
            }
        }
    }, [showSecondContainer]);

    return (
        <section className="tariff-section pt-6" id="tariffsection">
            <div className="container px-4 mx-auto">
                <div className="tariff-wrapper flex flex-col gap-6 p-3 md:p-6">
                    <div className="tariff-head pb-3">
                        <Heading as="h2">Bali Tour Package From Delhi</Heading>
                    </div>
                    <div className="tariff-body-footer flex flex-col gap-6">
                        <div className="tariff-body flex flex-col gap-4 px-3 md:px-6">
                            <div className="flex flex-col gap-1">
                                <p className="lead">
                                    Bali is an ideal destination for travellers
                                    from Delhi. It encompasses beautiful sandy
                                    beaches, natural forests, wonderful people,
                                    and a rich cultural endowment. From leisure
                                    and adventure to cultural tourism, Bali
                                    offers it all for tourists. From swimming at
                                    Kuta Beach to enjoying cultural performances
                                    in Ubud, this island is nothing else but a
                                    paradise.
                                    {!showSecondContainer && (
                                        <span
                                            className="font-medium view-more ml-4 cursor-pointer"
                                            onClick={handleViewMore}
                                        >
                                            View More
                                        </span>
                                    )}
                                </p>
                            </div>
                            <div
                                id="second-container"
                                ref={secondContainerRef}
                                className={`transition-all duration-500 overflow-hidden ${
                                    showSecondContainer
                                        ? "max-h-full opacity-100"
                                        : "max-h-0 opacity-0"
                                }`}
                            >
                                <div className="flex flex-col gap-1">
                                    {/* <Heading as="h3">
                                        Is the Thailand Honeymoon Package
                                        Expensive?
                                    </Heading> */}
                                    <p className="lead">
                                        Dimaak Tours offers one of the most
                                        affordable and comprehensive{" "}
                                        <a
                                            href="https://dimaak.com/bali"
                                            target="_blank"
                                        >
                                            <u>Bali tour packages</u>
                                        </a>{" "}
                                        from Delhi for the traveller. We make
                                        sure to make your tour as smooth and
                                        pleasant as possible with the help of
                                        our team of experts. We have perfect
                                        packages for you, right from the cheap
                                        tour package from Delhi to Bali to the
                                        luxury tour to Bali. When you choose
                                        Bali for a vacation, we help make your
                                        holiday as extraordinary as possible
                                        with a personalised itinerary and a
                                        special focus on every aspect where you
                                        are a couple going on a{" "}
                                        <a
                                            href="https://dimaak.com/bali/honeymoon-packages"
                                            target="_blank"
                                        >
                                            <u>honeymoon trip </u>
                                        </a>{" "}
                                        or going on a{" "}
                                        <a
                                            href="https://dimaak.com/bali/family-packages"
                                            target="_blank"
                                        >
                                            <u>family trip.</u>
                                        </a>
                                    </p>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Top Reasons to Visit Bali from Delhi
                                    </Heading>

                                    <p className="lead">
                                        Bali is on the bucket list of many
                                        travellers from Delhi.. From white,
                                        sandy beaches to adventurous trips, Bali
                                        has something for everyone. Here are the
                                        top reasons why you should consider
                                        taking a Bali tour package from Delhi.
                                    </p>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Cultural Richness:
                                    </Heading>
                                    <p className="lead">
                                        Bali is famous for its history and
                                        heritage. Travellers on a{" "}
                                        <strong>
                                            {" "}
                                            tour package from Delhi to Bali{" "}
                                        </strong>
                                        can immerse themselves in this unique
                                        culture.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Adventure and Relaxation:
                                    </Heading>
                                    <p className="lead">
                                        Bali has activities for serenity and{" "}
                                        <a
                                            href="https://dimaak.com/blog/bali-adventure-activities/"
                                            target="_blank"
                                        >
                                            <u>adventure activities;</u>
                                        </a>{" "}
                                        you can climb Mount Batur or have a
                                        leisure time at a five-star spa. It can
                                        be recommended for travellers who like
                                        thrilling activities as well as for
                                        those who want to spend time quietly.
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                        Bali's Top Attractions You Must
                                        Experience
                                    </Heading>
                                    <p className="lead">
                                        Bali is a perfect place for a tourist on
                                        a Bali tour package from Delhi because
                                        it has a number of attractions that will
                                        appeal to every traveller. From learning
                                        new cultures, admiring picturesque
                                        scenery, or even exploring new
                                        destinations, these places will make
                                        your trip memorable.
                                    </p>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Ubud: A Hub of Culture and Spirituality
                                    </Heading>
                                    <p className="lead">
                                        In the heart of Bali lies a place where
                                        art, spirituality, and nature coexist in
                                        perfect harmony. When staying in Ubud,
                                        you can experience beautiful scenery of
                                        greenery and nature; its cultural values
                                        are attributed to Bali. It’s a place
                                        where you can discover Bali’s culture in
                                        terms of art, traditional accessories,
                                        and active centres of Balinese
                                        spirituality.
                                    </p>
                                    <p className="lead"><strong>Ubud’s Main Attractions:</strong></p>

                                    <ul>
                                        <li>
                                            <strong>Monkey Forest:</strong>{" "}
                                            Visit traditional temples here and
                                            even play with friendly monkeys deep
                                            into the forest's core.
                                        </li>
                                        <li>
                                            <strong>Ubud Palace:</strong> Visit
                                            the royal palace in the evening and
                                            watch traditional Balinese dances.
                                        </li>
                                        <li>
                                            <strong>
                                                Campuhan Ridge Walk:
                                            </strong>{" "}
                                            Take a beautiful walk watching the
                                            beautiful ridge view of the hills
                                            with beautiful rice paddies in the
                                            background.
                                        </li>
                                        <li>
                                            <strong>Tirta Empul Temple:</strong>{" "}
                                            Take part in a cleansing ritual at
                                            one of Bali’s oldest water temples
                                        </li>
                                    </ul>
                                </div>

                                
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Tanah Lot Temple: A Stunning Coastal
                                        Landmark
                                    </Heading>
                                    <p className="lead">
                                        This temple is constructed on a rock by
                                        the seashore, which makes it quite
                                        similar to the one on the island of
                                        Bali, especially in the evening when the
                                        sun is setting. This is one of the most
                                        cherished cultural attractions in Bali
                                        for everyone who books a Bali Indonesia
                                        tour package from Delhi.
                                    </p>
                                    
                                    <p className="lead"><strong>What to Do at Tanah Lot:</strong></p>
                                    <ul>
                                        <li>
                                            <strong>Sunset Views:</strong> Take
                                            pictures of breathtaking views of
                                            the temple with a stunning sunset in
                                            the background.
                                        </li>
                                        <li>
                                            <strong>Cultural Insights:</strong>{" "}
                                            Learn more on the religious
                                            importance of the temple and its
                                            importance to Balinese Hindus.
                                        </li>
                                        <li>
                                            <strong>Local Markets:</strong> Walk
                                            around other stalls and stands to
                                            find more Balinese specialities and
                                            local products to bring home.
                                        </li>
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Bali’s Lively Beach Scene: Kuta Beach
                                    </Heading>
                                    <p className="lead">
                                        Popular for its lively atmosphere, Kuta
                                        Beach attracts surf lovers, sun lovers,
                                        and those who like{" "}
                                        
                                            nightlife activities.
                                       
                                        The beautiful length of sand and the
                                        welcoming waves make it a favourite spot
                                        to relax or play along the shore, thanks
                                        to cheap tour packages from Delhi to
                                        Bali.You can check more about Bali’s
                                        beaches{" "}
                                        <a
                                            href="https://dimaak.com/blog/20-best-beaches-in-bali/"
                                            target="_blank"
                                        >
                                            <u>here.</u>
                                        </a>
                                        
                                    </p>
                                    <p className="lead"><strong>Activities at Kuta Beach:</strong></p>
                                    <ul>
                                        <li>
                                            <strong>Surfing:</strong> Perfect
                                            for beginners and experienced
                                            surfers alike; Kuta’s waves are some
                                            of Bali’s most popular.
                                        </li>
                                        <li>
                                            <strong>Nightlife:</strong> As the
                                            sun sets, the area comes alive with
                                            beach bars, clubs, and restaurants
                                            offering lively entertainment.
                                        </li>
                                        <li>
                                            <strong>Shopping:</strong> Visit
                                            various supermarkets and shops to
                                            buy beachwear, local souvenirs, and
                                            gifts.
                                        </li>
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                        Mount Batur: An Adventurer’s Dream
                                    </Heading>
                                    <p className="lead">
                                        Located in the northeast of Bali, this
                                        is an active volcano that you can climb
                                        during your vacation. The view from the
                                        top in the morning light is
                                        breathtaking, and this sunrise trek is
                                        one of the most popular activities
                                        included in tour packages from Delhi to
                                        Bali, Indonesia.
                                    </p>
                                    
                                    <p className="lead"><strong>What to Do at Mount Batur:</strong></p>
                                    
                                    
                                    <ul>
                                        <li>
                                        <strong>Sunrise Trek:</strong> Start your hike early in the morning, to catch a glimpse of the rising sun over the volcanic terrain.

                                        </li>
                                        <li>
                                        <strong>Hot Springs: </strong> Proceed to the hot spring near the area, the Sulphur Hot Springs with a stunning view of Lake Batur.
                                        </li>
                                        <li>
                                        <strong>Camping: </strong> To have a closer touch with nature, you can consider overnight camping near to the volcanic floor.

                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Tegallalang Rice Terraces: A Scenic Masterpiece</Heading>
                                    <p className="lead">
                                    The beautiful scenery of Tegallalang Rice Terraces is considered one of the best scenes of Bali. These beautiful green paddy terraces are a reflection of Bali’s agricultural roots and are a paradise for photographers on Indonesia Bali tour packages from Delhi.
                                    </p>
                                    <p className="lead">
                                        <strong>Things to Do at Tegallalang:</strong>
                                    </p>
                                    <ul>
                                        <li>Bali Swing: Experience the thrill of swinging over the picturesque rice terraces for an unforgettable photo opportunity.</li>
                                        <li>Photography: The beauty and colour of the Chinese terraced fields are perhaps best captured at sunrise or sunset.</li>
                                        <li>Coffee Plantations: Visit some coffee farms and taste Bali’s speciality, Luwak Coffee.</li>
                                       
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Cliffside Serenity: Uluwatu Temple</Heading>
                                    <p className="lead">
                                    This temple, located at the edge of the North Bali sea cliffs, is breathtaking and definitely part of the island's culture. Uluwatu is also famous for the Kecak dance that takes place at sunsets, making it a must-see attraction for people who choose a Bali tour package from Delhi.If you want to know more about other temples to visit in Bali then <a href="https://dimaak.com/blog/temples-to-visit-in-bali/" target="_blank"><u> check this.</u></a>
                                    </p>
                                    <p className="lead">
                                        <strong>Attractions at Uluwatu Temple:</strong>
                                    </p>
                                    <ul>
                                        <li><strong>Kecak Dance Performance:</strong> Watch the amazing traditional fire dance performance set against a beautiful sunset backdrop.</li>
                                        <li><strong>Clifftop Walks:</strong> Walk around the cliff facing the ocean and soak in the scenery from the paths near the temple.</li>
                                        <li><strong>Surfing:</strong> Uluwatu Beach is a well-liked surfing place for advanced surfers and is also blessed with stunning vistas.</li>
                                        
                                    </ul>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Luxury and Relaxation: Nusa Dua</Heading>
                                    <p className="lead">
                                    Famous for its beautiful, wide, and pristine sandy beaches, luxurious hotels, and vacation aura, Nusa Dua is one of the must-visit destinations in Bali. This luxury area is ideal for tourists who are looking for a serene escape while enjoying top-tier amenities, making it a popular choice in <strong>Bali tour packages from New Delhi.</strong>

                                    </p>
                                    <p className="lead">
                                        <strong>Things to do in Nusa Dua:</strong>
                                    </p>
                                    <ul>
                                        <li><strong>Snorkelling and Diving:</strong> Snorkel and scuba dive through the warm waters and watch the beautiful creatures of the sea.</li>
                                        <li><strong>Relaxation:</strong> Sunbathe at the white sandy beaches or perhaps, indulge in a bit of luxury at one of the finest coastal Resorts.</li>
                                        <li><strong>Devdan Show:</strong> Join the Devdan Show, an entertaining show focused on Indonesian dance and music culture.</li>
                                        
                                    </ul>
                                    <p className="lead">
                                    At Dimaak Tours, we always ensure that we provide the best <strong>Bali tour package from Delhi,</strong> tailored to suit your preferences. Whether you're looking for a <strong> cheap tour package from Delhi to Bali </strong>or a luxurious vacation, our expert team will ensure that your Bali trip is well-planned and unforgettable. We arrange your travel to Bali with a private and comfortable itinerary to deliver you the best travel experience. Contact Dimaak for your next adventure and discover Bali safely!

                                    </p>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">
                                    Travel Tips for a Smooth Bali Trip from Delhi
                                    </Heading>
                                    <p className="lead">
                                    Travelling to Bali from Delhi can therefore be interesting if one gets the right information on how to plan a trip. Below are some helpful travel tips that can guide you and make your Bali tour package from Delhi enjoyable without any hassle.
                                    </p>
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Visa and Documentation:</Heading>

                                    <ul>
                                        <li>
                                            <strong>Visa on Arrival:</strong>  Bali allows visas on arrival for holders of the Indian passport, which is valid for 30 days. For these longer stays, make sure to look into visas before you confirm the Bali Indonesia tour package from Delhi.

                                        </li>
                                        <li>
                                            <strong>Required Documents:</strong> Be sure to have a valid passport, the return flight tickets, and accommodation evidence; this will allow a smooth entry.
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">The Best Time to Visit:</Heading>

                                    <ul>
                                        <li>
                                            <strong>Peak Season:</strong> The dry season is between April and October, which is probably a good time for people who are planning to travel to Bali to engage in outdoor activities
                                        </li>
                                        <li>
                                            <strong>Off-Peak Season:</strong>
                                            The off-season is from November to March, but the climate is not very favourable, with almost no rainfall during this period, and less crowded, making it cheaper for the tour packages from Delhi to Bali.
                                        </li>
                                       
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Packing Guide:</Heading>

                                    <ul>
                                        <li>
                                            <strong>Essentials:</strong> Take casual wear, beach wear, sunscreen, and a hat due to the warm climate of the region.
                                        </li>
                                        <li>
                                            <strong>Adventure Gear:</strong> Take comfortable shoes for trekking if you are interested in climbing Mount Batur or if you’re going to the forests of Ubud.
                                        </li>
                                        <li>
                                            <strong>Cultural Sensitivity:</strong> Include modest clothing for temple visits, which is often part of tour packages from Delhi to Bali Indonesia.
                                        </li>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">Flight Information:</Heading>

                                    <ul>
                                        <li>
                                            <strong>Direct Flights:</strong> Some Airlines fly from New Delhi to Bali; these include Air India and Garuda Indonesia, among others.
                                        </li>
                                        <li>
                                            <strong>Travel Time:</strong> The average duration of the flight from New Delhi to Bali is approximately between 8 and 9 hours.
                                        </li>
                                        <li>
                                            <strong>Book Early:</strong> When planning to book your Bali tour packages from New Delhi, the next thing that you need to do is to make sure that you book your flights well in advance, especially during the festive seasons
                                        </li>
                                        
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h3">Why Book Your Bali Tour with Us?</Heading>
<p className="lead">
At Dimaak Tours, we also ensure that you have the best Bali tour package from Delhi along with all the necessary arrangements. We offer professional planning and individual schedules of any complexity for an ideal and unique experience in Bali.

</p>
                                   
                                </div>

                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                    Expert Planning:
                                    </Heading>

                                    <ul >
                                        <li>
                                        We take care of all the formalities so that your Bali tour packages from Delhi are hassle-free right from the beginning.

                                        </li>
                                        <li>
                                        Our team is familiar with all the attractions in Bali, as well as the great places that tourists may have never heard of before.

                                        </li>
                                    
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                    Customised Itineraries:
                                    </Heading>

                                    <ul >
                                        <li>
                                        Depending on what you want: the adventurous, the leisurely, or the cultural traveller, our itineraries are as unique as you are!

                                        </li>
                                        <li>
                                        You get flexibility with our tour packages from Delhi to Bali Indonesia for your special needs.

                                        </li>
                                    
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-1">
                                    <Heading as="h4">
                                    Value and Trust:
                                    </Heading>

                                    <ul >
                                        <li>
                                        Our prices are comparatively cheaper than our competitors, which makes it easier to find cheap tour packages from Delhi to Bali

                                        </li>
                                        <li>
                                        We have gained our reputation from the many years we have been in operation and from providing services to clients who are on Bali Indonesia tour packages from Delhi.

                                        </li>
                                    
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {showSecondContainer && (
                            <div className="traffic-footer flex-wrap flex items-center justify-evenly gap-3 md:gap-5 pt-4">
                                <div>
                                    <a
                                        target="_blank"
                                        href="https://wa.me/919600099777?text=Hi,%20I%20am%20Interested%20in%20Thailand%20Honeymoon%20Packages."
                                    >
                                        <Button
                                            className="flex items-center gap-3"
                                            variant="green"
                                            onClick={handleViewLess}
                                        >
                                            <Image
                                                src={Buttonwhatsapp}
                                                alt="whatsappimage"
                                            />
                                            <span>Get Quote</span>
                                        </Button>
                                    </a>
                                </div>
                                <div
                                    className="flex items-center gap-3 cursor-pointer"
                                    onClick={handleViewLess}
                                >
                                    <span className="text-link">View Less</span>
                                    <Image src={RightIcon} alt="right icon" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Tariff;
